import React from 'react';
import './EggStories.scss';
import { useLoginRedirect } from 'hooks/useLoginRedirect';
import { Story } from 'components/AdrianSanctuary/Story';
import { Egg } from './Egg';

export const EggStories = () => {
  useLoginRedirect();

  return (
    <Egg>
      <div>
        <div className="egg-stories">
          <h1>Adrian&#39;s Sanctuary</h1>
          <Story />
        </div>
      </div>
    </Egg>
  );
};
